import React, { useState } from 'react';
import './SliderDiagnostic.css';

const SliderDiagnostic: React.FC = () => {
  const [value, setValue] = useState(5);
  
  const handleSliderChange = (newValue: number) => {
    console.log('🎛️ DIAGNOSTIC: Slider value changed to:', newValue);
    setValue(newValue);
  };

  const percentage = ((value - 1) / (10 - 1)) * 100;

  return (
    <div className="diagnostic-container">
      <h2>🔧 Slider Diagnostic Test</h2>
      <p>Current Value: <strong>{value}</strong></p>
      
      {/* Simple HTML Range Input for comparison */}
      <div className="test-section">
        <h3>Native HTML Slider (Control Test)</h3>
        <input 
          type="range" 
          min="1" 
          max="10" 
          value={value}
          onChange={(e) => handleSliderChange(Number(e.target.value))}
        />
      </div>

      {/* Custom Slider Test */}
      <div className="test-section">
        <h3>Custom Slider Test</h3>
        <div className="custom-slider-container">
          <div 
            className="custom-track"
            onClick={(e) => {
              console.log('🎛️ DIAGNOSTIC: Track clicked');
              const rect = e.currentTarget.getBoundingClientRect();
              const x = e.clientX - rect.left;
              const newPercentage = Math.max(0, Math.min(1, x / rect.width));
              const newValue = Math.round(1 + newPercentage * (10 - 1));
              handleSliderChange(newValue);
            }}
          >
            <div className="custom-fill" style={{ width: `${percentage}%` }} />
            <div 
              className="custom-thumb" 
              style={{ left: `calc(${percentage}% - 10px)` }}
              onMouseDown={(e) => {
                console.log('🎛️ DIAGNOSTIC: Thumb mouse down');
                e.preventDefault();
                
                const track = e.currentTarget.parentElement!;
                const trackRect = track.getBoundingClientRect();
                
                const handleMouseMove = (moveEvent: MouseEvent) => {
                  const x = moveEvent.clientX - trackRect.left;
                  const newPercentage = Math.max(0, Math.min(1, x / trackRect.width));
                  const newValue = Math.round(1 + newPercentage * (10 - 1));
                  handleSliderChange(newValue);
                };

                const handleMouseUp = () => {
                  document.removeEventListener('mousemove', handleMouseMove);
                  document.removeEventListener('mouseup', handleMouseUp);
                };

                document.addEventListener('mousemove', handleMouseMove);
                document.addEventListener('mouseup', handleMouseUp);
              }}
            />
          </div>
        </div>
      </div>

      {/* Button Test */}
      <div className="test-section">
        <h3>Button Text Test</h3>
        <button className="test-button">
          Save My Preferences
        </button>
        <button className="test-button-inline-style" style={{ 
          background: '#1F6C4F', 
          color: 'white', 
          border: 'none', 
          padding: '14px 28px', 
          borderRadius: '8px',
          fontSize: '16px',
          fontWeight: '600'
        }}>
          Inline Style Button
        </button>
      </div>
    </div>
  );
};

export default SliderDiagnostic; 